import { render, staticRenderFns } from "./noReturnPolicy.vue?vue&type=template&id=7429a43e&scoped=true"
import script from "./noReturnPolicy.vue?vue&type=script&lang=js"
export * from "./noReturnPolicy.vue?vue&type=script&lang=js"
import style0 from "./noReturnPolicy.vue?vue&type=style&index=0&id=7429a43e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7429a43e",
  null
  
)

export default component.exports